import { Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { Button } from '../components/atoms/Button';
import { Page } from '../components/atoms/Page';
import { Container } from '../components/layouts/Container';
import { LOGIN } from '../constants/routing';
import { useSignInReport } from '../hooks/analytic/useSignInReport';

const INSCRIPTION_DOUBLON_MSG2_ID = 'inscription-doublon-msg2';

export const InscriptionDoublonPage = () => {
  const { t } = useTranslation();
  const [eventSignIn, setEventSignIn] = useState('');
  useSignInReport({ event: eventSignIn });
  const location = useLocation();
  const locale = location.pathname.split('/')[1];
  const { email } = (location.state ?? {}) as { email?: { value?: string } };
  const emailValue = email?.value;
  const emailText = emailValue ? ` : ${emailValue}` : '';

  return (
    <Page>
      <Container containerType="narrow" sx={{ mt: '4.5rem' }}>
        <Typography variant="h1">{t('inscription.doublon.h1')}</Typography>
        <Typography sx={{ mt: '1.5rem' }}>{t('inscription.doublon.msg1', { emailText })}</Typography>
        <Typography id={INSCRIPTION_DOUBLON_MSG2_ID} sx={{ my: '1.5rem' }}>
          {t('inscription.doublon.msg2')}
        </Typography>
        <Button
          aria-describedby={INSCRIPTION_DOUBLON_MSG2_ID}
          href={`${LOGIN}?language=${locale}`}
          target="_self"
          variant="outlined"
          onClick={() => {
            setEventSignIn('security_sign_in_attempt');
          }}
        >
          {t('header.signin')}
        </Button>
      </Container>
    </Page>
  );
};

export default InscriptionDoublonPage;
